export enum PaymentCycle {
    Monthly,
    Quarterly,
    Yearly,
}